import { TYPE, TYPE_DATA } from '@/constants/filesExtensions';

export const readURL = (file) =>
  new Promise((res, rej) => {
    const reader = new FileReader();
    reader.onload = (e) => res(e.target.result);
    reader.onerror = (e) => rej(e);
    reader.readAsDataURL(file);
  });

export const dataURItoBlob = (dataURI) => {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;

  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
};

export const urlToFile = async (url, name = 'image.jpg') => {
  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], name, { type: blob.type });
  return file;
};

export const getFileExtension = (fileName) => fileName.split('.').pop();

export const getDownloadLink = async (url, fileName) => {
  const file = await urlToFile(url, fileName);

  if (!file) {
    return url;
  }

  return URL.createObjectURL(file);
};

export const getDownloadLinkByType = (rawData, fileName, baseType = TYPE.pdf) => {
  const bytes = Uint8Array.from(atob(rawData), (element) => element.charCodeAt(0));
  const type = TYPE_DATA[baseType];
  const fileNameWithExtension = `${fileName}${type.extension}`;
  const file = new File([bytes], fileNameWithExtension, { type: type.mimeType });

  return URL.createObjectURL(file);
};

export const downloadFile = (url, fileName = '') => {
  const linkElement = document.createElement('a');
  linkElement.target = '_blank';
  linkElement.href = url;
  linkElement.download = fileName;
  linkElement.click();
  URL.revokeObjectURL(linkElement.href);
};
